import { z } from "zod";

export enum NEWSLETTER_SCHOOLFORM {
    gs = "gs",
    sek = "sek",
    und = "",
}

export const NewsletterRolesScheme = z.record(z.string(), z.string());

export const NewsletterSubjectsScheme = z.record(z.string(), z.record(z.string(), z.string()));

export const NewsletterScheme = z
    .object({
        email: z.string().email(),
        firstname: z.string().default(""),
        lastname: z.string().default(""),
        salutation: z.string().default(""),
        role: z.string().default(""),
        schoolform: z.string().default(""),
    })
    .passthrough();

export type NewsletterType = z.infer<typeof NewsletterScheme>;
